import { render, staticRenderFns } from "./ImageCanvas.vue?vue&type=template&id=6701ca1b&"
import script from "./ImageCanvas.vue?vue&type=script&lang=js&"
export * from "./ImageCanvas.vue?vue&type=script&lang=js&"
import style0 from "./ImageCanvas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6701ca1b')) {
      api.createRecord('6701ca1b', component.options)
    } else {
      api.reload('6701ca1b', component.options)
    }
    module.hot.accept("./ImageCanvas.vue?vue&type=template&id=6701ca1b&", function () {
      api.rerender('6701ca1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/common/ImageCanvas.vue"
export default component.exports